import {type MutationTree} from 'vuex';

const mutations: MutationTree<ModuleServicesState> = {
    setCalendarOptions(state, payload)
    {
        state.calendarOptions = payload;
    },
    setBookingInformation(state, information: BookingInformation)
    {
        state.bookingInformation = information;
    },
    setDefaultAddress(state, address: Address)
    {
        state.defaultAddress = address;
    },
    setBookingServices(state, services: BookingServiceOption[])
    {
        state.bookingServices = services;
    },
    setBookingCategories(state, categories: ICategory[])
    {
        state.bookingCategories = categories;
    },
    setBookingCalendars(state, calendars: BookingCalendarOption[])
    {
        state.bookingCalendars = calendars;
    },
    setBookingData(state, data: BookingData)
    {
        state.bookingData = data;
    },
    setServiceData(state, data: BookingServiceData[])
    {
        state.bookingService = data;
    },
};

export default mutations;